module.exports = __webpack_public_path__ + "static/vtu-5f47a3e529e63933c5153ea58d2e0d55.jpg";